// extracted by mini-css-extract-plugin
export default {"attachFile":"NewCaseForm2_attachFile__dibYT","dropBox":"NewCaseForm2_dropBox__+rFWQ","agrement":"NewCaseForm2_agrement__iosSP"};